<template>
    <section>
        <h4>Device Details</h4>
        <p>What device will you be using?</p>
        <div class="selector-cards">
            <selector-card
                title="Huawei"
                label="5G CPE PRO 2"
                :isSelected="device === 'huawei'"
                @select="select('huawei')">
            </selector-card>
            <selector-card
                title="Other"
                label="For example ZTE or Nokia"
                :isSelected="device === 'generic'"
                @select="select('generic')">
            </selector-card>
        </div><!-- end.selector-box -->
        <section-footer
            :buttons="buttons"
            @next="next()"
            @back="back()">
        </section-footer>
    </section>
</template>

<script>
import SelectorCard from '@/components/SelectorCard'
import SectionFooter from '@/components/SectionFooter'

export default {
    components: {
        SelectorCard,
        SectionFooter,
    },
    computed: {
        provider() {
            return this.$store.getters['provider'];
        },
        device() {
            return this.$store.getters['device'];
        },
        buttons() {
            return [
                {
                    label: 'Back',
                    event: 'back',
                    class: 'ghost',
                    disabled: false
                },
                {
                    label: 'Next',
                    event: 'next',
                    class: '',
                    disabled: !this.device
                }
            ]
        }
    },
    methods: {
        select(device) {
            this.$store.commit('updateDevice', device);
        },
        next() {
            console.log(this.device);
            let route = `setup-vodacom-device-${this.device}`;
            this.$router.push({name: route});
        },
        back() {
            this.$router.push({name: 'hardware'});
        },
    }
}
</script>